'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./page/cart/cart'));
    processInclude(require('./components/wishlistHeart'));
});
